import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "bulma/css/bulma.css";
import Buefy from "buefy";
import "buefy/dist/buefy.css";

import "@/styles/index.scss";
import "@/firebase";

const script = document.createElement("script");
script.src = "https://www.airbnb.com.my/embeddable/airbnb_jssdk";
script.async = true;
document.body.appendChild(script);

Vue.config.productionTip = false;

Vue.use(Buefy);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
